import { useEffect, useState } from "react";
import { get } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";

// Maps the backend node status into an honest evidence status label.
function toEvidenceStatus(s) {
  if (!s) return "not_yet_connected";
  if (s.status === "active") return "live";
  if (s.status === "unconfigured" || s.status === "misconfigured") return "not_yet_connected";
  if (s.status === "unreachable") return "unavailable";
  return "not_yet_connected";
}

export function NodeStatus({ withLabel = true }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let live = true;
    const load = () => get("/katlas/status").then((d) => live && setStatus(d)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { live = false; clearInterval(t); };
  }, []);

  const ev = toEvidenceStatus(status);
  return (
    <div className="flex items-center gap-2" data-testid="node-status">
      {withLabel && <span className="text-xs uppercase tracking-[0.14em] text-mill-muted">KATLAS node</span>}
      <StatusBadge status={ev} />
    </div>
  );
}
